import CallAPI from "../../../utility/functions/getData";
import {
  setAlertWithTitle,
  setSpinnerLoading,
} from "../../../utility/Redux/modal";
import deleteWholeDatabase from "../../../utility/functions/deleteWholeDatabase";
import dataToLocal from "../../../utility/component/dataToLocal";

export const GetSaleSummary = (
  data,
  token,
  dispatch,
  setSummaryList,
  setTotalPages,
  setCurrentPage
) => {
  dispatch(setSpinnerLoading("Loading..."));
  deleteWholeDatabase("trial_balance_under_group_wise");

  CallAPI(
    "/api/trialBalance/trial-Balance-UG-Wise",
    data,
    token,
    (e) => {
      if (!e.data.error) {
        setTotalPages(e.data.response.pagination.totalPages);
        setCurrentPage(e.data.response.pagination.page);
        if (e.data.response.data[0]) {
          setSummaryList(e.data.response.data);
          dataToLocal("trial_balance_under_group_wise", e.data.response.data, [
            {
              ...data,
              ICODE: 1,
            },
          ]);
        } else {
          setSummaryList([]);
          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "No Records Found",
            })
          );
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Something Went Wrong.",
          })
        );
      }
    },
    dispatch,
    () => {
      dispatch(setSpinnerLoading(false));
    }
  );
};
